import { TableCell, TableHead, TableRow } from '@material-ui/core';
import React from 'react';

const WLDTbleHeadingRow = ({ styles, isMobile }) => {
  return (
    <TableHead>
      <TableRow style={styles.tableRow}>
        <TableCell
          style={{
            ...styles.modalTableHeaderCell,
            padding: 0,
            width: '80px',
          }}
          className="sticky"
          align="right"
        >
          Date
        </TableCell>
        <TableCell
          style={{
            ...styles.modalTableHeaderCell,
            padding: 0,
            width: isMobile ? '65px' : '44px',
          }}
          className="sticky"
          align="right"
        >
          Stock
        </TableCell>

        <TableCell
          style={{
            ...styles.modalTableHeaderCell,
            padding: 0,
            width: isMobile ? '65px' : '44px',
          }}
          className="sticky"
          align="right"
        >
          Ticker
        </TableCell>
        <TableCell
          style={{
            ...styles.modalTableHeaderCell,
            padding: 0,
            width: '80px',
          }}
          className="sticky"
          align="right"
        >
          Expiry
        </TableCell>

        <TableCell
          style={{
            ...styles.modalTableHeaderCell,
            width: isMobile ? '65px' : '44px',
          }}
          className="sticky"
          align="right"
        >
          Strike
        </TableCell>

        <TableCell
          style={{ ...styles.modalTableHeaderCell, width: '44px' }}
          className="sticky"
          align="right"
        >
          P/C
        </TableCell>

        <TableCell
          style={{
            ...styles.modalTableHeaderCell,
            padding: 0,
            width: isMobile ? '75px' : '44px',
          }}
          className="sticky"
          align="right"
        >
          Price
        </TableCell>
        <TableCell
          style={{
            ...styles.modalTableHeaderCell,
            padding: 0,
            width: isMobile ? '75px' : '44px',
          }}
          className="sticky"
          align="right"
        >
          RR$
        </TableCell>
      </TableRow>
    </TableHead>
  );
};
export default WLDTbleHeadingRow;



// WEBPACK FOOTER //
// ./src/components/Modals/WatchListDelte/components/WLDtableHeadingRow.jsx